import { useQuery } from "@tanstack/react-query"
import { fetchMyTickets } from "api/fetchMyTickets"
import ProfileLayout from "components/Layout/Profile/ProfileLayout"
import TicketTab from "components/page_components/User/Tabs/MyTickets/TicketTab"
import { NextSeo } from "next-seo"
import { motion } from "framer-motion"
import ProfileSkeleton from "components/Skeleton/ProfileSkeleton"

const Tickets = () => {
    const { data, isLoading, isSuccess } = useQuery({
        queryKey: ["ticket"],
        queryFn: fetchMyTickets,
    })
    
    const ticketsData = data?.payload
    
    return (
        <>
            <NextSeo noindex nofollow />
            <ProfileLayout>
                {isLoading ? (
                    <ProfileSkeleton type="card" />
                ) : (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                    >
                        <TicketTab tickets={ticketsData} isSuccess={isSuccess} />
                    </motion.div>
                )}
            </ProfileLayout>
        </>
    )
}

export default Tickets
